<template>
    <b-modal
        id="confirm-remove-card"
        title="Confirm"
        centered
        @hidden="$emit('resetDeleteCardInfo')">
        <p class="text-center">Are you sure you want to remove this card?</p>
        <template slot="modal-footer">
            <b-button @click="handleCancelDelete">Cancel</b-button>
            <b-button variant="primary" @click="confirmDelete">Yes, Remove</b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    methods: {
        handleCancelDelete() {
            this.$emit('resetDeleteCardInfo');
            this.$root.$emit('bv::hide::modal', 'confirm-remove-card');
        },
        confirmDelete() {
            this.$emit('deleteCard');
            this.$root.$emit('bv::hide::modal', 'confirm-remove-card');
        }
    }
}
</script>
